export default __webpack_public_path__ + "static/media/correre-naturale.94490469.png";